import axios from "../../axios.js";
import router from "../../router/index";
import { createRequestSequence } from "../requestSequence";

const allProfilesSeq = createRequestSequence();
const waitingProfilesSeq = createRequestSequence();
const triedToLoginSeq = createRequestSequence();
const userCommissionsSeq = createRequestSequence();
const smsListForUserSeq = createRequestSequence();
const smsListForAllUsersSeq = createRequestSequence();

const getProfileWithWatingStatus = ({ commit }, data) => {
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const filter_param = data.search_param
    ? `filter_param=${data.search_param}&`
    : "";
  const sort_by = data.filter_param ? `sort_by=${data.filter_param}&` : "";
  const sort_type = data.third_filter_param
    ? `sort_type=${data.third_filter_param}&`
    : "";
  let url = `api/profile/needVerification?${page_number}${on_page}${filter_param}${sort_by}${sort_type}`;
  url = url.slice(0, -1);
  const requestId = waitingProfilesSeq.next();
  axios
    .get(url)
    .then((response) => {
      if (!waitingProfilesSeq.isLatest(requestId)) return;
      commit("SET_PROFILE_WITH_WAITING_STATUS", response);

      commit("SET_PROFILE_WITH_WAITING_STATUS_ERROR", false);
    })
    .catch((err) => {
      if (!waitingProfilesSeq.isLatest(requestId)) return;
      commit("SET_PROFILE_WITH_WAITING_STATUS_ERROR", err);
    });
};

const getAllProfiles = async ({ commit }, data) => {
  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";
  const param = data.search_param ? `param=${data.search_param}&` : "";
  let employee_status = "";
  let waiting_without_payment = "";
  if (data.filter_param === "WAITING_WITHOUT_PAYMENT") {
    waiting_without_payment = `need_verification_and_without_payment=true&`;
  }
  if (data.filter_param === "WAITING_WITH_STARTED_PAYMENT") {
    waiting_without_payment = `need_verification_and_without_payment=false&`;
  }
  if (
    data.filter_param !== "WAITING_WITHOUT_PAYMENT" &&
    data.filter_param !== "WAITING_WITH_STARTED_PAYMENT"
  ) {
    employee_status =
      data.filter_param && data.filter_param !== "ALL"
        ? `employee_status=${data.filter_param}&`
        : "";
  }

  let url =
    "api/profile/noWaiting?" +
    page_number +
    on_page +
    param +
    employee_status +
    waiting_without_payment;
  url = url.slice(0, -1);
  const requestId = allProfilesSeq.next();
  await axios
    .get(url)
    .then((response) => {
      if (!allProfilesSeq.isLatest(requestId)) return;
      commit("SET_PROFILES", response.data);
      commit("SET_PROFILES_PAGINATION", {
        page_number: response.data.page_number,
        on_page: response.data.on_page,
        total: response.data.total,
      });
      commit("SET_PROFILES_ERROR", false);
    })
    .catch((err) => {
      if (!allProfilesSeq.isLatest(requestId)) return;
      commit("SET_PROFILES_ERROR", err);
      console.log(err);
    });
};

const getAllProfilesWhoTriedToLogIn = async ({ commit }, data) => {
  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";

  let url = "api/profile/triedToLogIn?" + page_number + on_page;
  const requestId = triedToLoginSeq.next();
  await axios
    .get(url)
    .then((response) => {
      if (!triedToLoginSeq.isLatest(requestId)) return;
      commit("SET_PROFILES_WHO_TRIED_TO_LOGIN", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const changeEmployeeStatus = async ({ commit }, data) => {
  const url = `api/profile/changeStatus/${data.id}?employee_status=${data.employee_status}`;
  return await axios
    .put(url, {
      message: data.message,
    })
    .then((response) => {
      commit("CHANGE_EMPLOYEE_STATUS", "Pomyślnie zmieniono status");
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

const getUserByPhone = ({ commit }, data) => {
  const url = `/api/user/${data.phone}`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_USER_BY_PHONE", response.data);
    })
    .catch((err) => {
      commit("SET_USER_BY_PHONE", err.response.data);
    });
};

const getUserById = async ({ commit }, data) => {
  const url = `/api/user/id/${data.userId}`;
  try {
    if (!data.userId) {
      commit("SET_USER_BY_ID", null);
      return;
    }
    const response = await axios.get(url);
    commit("SET_USER_BY_ID", response.data);
  } catch (error) {
    commit("SET_USER_BY_ID", null);
  }
};

const getUserByIdFromMainApp = async ({ commit }, data) => {
  const url = `/api/user/id/${data.userId}`;
  if (!data.userId) {
    commit("SET_MAIN_APP_USER", null);
    return;
  }
  try {
    const response = await axios.get(url);
    commit("SET_MAIN_APP_USER", response.data);
  } catch (error) {
    commit("SET_MAIN_APP_USER", null);
  }
};

const getDeletedUsers = ({ commit }) => {
  const url = `/api/admin/all-delete-request`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_DELETED_USERS", response.data);
    })
    .catch((err) => {
      commit("SET_DELETED_USERS", err.response.data);
    });
};
const deleteUser = ({ commit, dispatch }, data) => {
  const url = `/api/admin/${data.userId}/delete`;
  axios
    .post(url)
    .then(() => {
      commit("SET_IS_DELETED", true);
      dispatch("getDeletedUsers");
    })
    .catch(() => {
      commit("SET_IS_DELETED", false);
    });
};
const getProfilesWithoutPagination = ({ commit }) => {
  const on_page = `?on_page=1000000`;
  const url = `/api/profile/noWaiting${on_page}`;

  axios
    .get(url)
    .then((response) => {
      commit("SET_PROFILES", response);
    })
    .catch((err) => {
      commit("SET_PROFILES_ERROR", err);
      console.log(err.response);
    });
};
const sendUsersMessage = ({ commit }, data) => {
  axios
    .post(data.url, data.message)
    .then(() => {
      commit("SEND_NOTIFICATION_SUCCESS", {
        message: "Pomyślnie wysłano wiadomość",
        status: true,
      });
    })
    .catch((err) => {
      console.log(err.response);
      commit("SEND_NOTIFICATION_FAIL", {
        message: "Błąd przy wysyłaniu wiadomości",
        status: false,
      });
    });
};

const sendMessageToUsers = async ({ commit }, data) => {
  const user_id = data.user_id ? data.user_id : "";
  const group_type = data.group_type ? data.group_type.toUpperCase() : null;
  const message = data.message ? data.message : "";
  const from_admin_panel = data.from_admin_panel
    ? data.from_admin_panel
    : false;
  const forSingleUser = data.singleUser ? true : false;
  const without_sms_notification = data.without_sms_notification
    ? data.without_sms_notification
    : false;
  const phoneNumbers = data.phone_numbers ? data.phone_numbers : null;
  const partnersIds = data.partners_ids ? data.partners_ids : null;
  const merketingAgreement = data.not_required_marketing_agreement;

  const url = `/api/chat/send`;
  const bodyFormData = new FormData();
  bodyFormData.append("without_sms_notification", without_sms_notification);
  bodyFormData.append("message", message);
  bodyFormData.append("user_id", user_id);
  bodyFormData.append("not_required_marketing_agreement", merketingAgreement);
  bodyFormData.append("from_admin_panel", from_admin_panel);
  if (phoneNumbers && phoneNumbers.length && phoneNumbers.length > 0) {
    bodyFormData.append("phone_numbers", phoneNumbers);
  }
  if (partnersIds && partnersIds.length && partnersIds.length > 0) {
    bodyFormData.append("partners_ids", partnersIds);
  }
  if (!forSingleUser) {
    bodyFormData.append("group", group_type);
  }
  await axios
    .post(url, bodyFormData)
    .then(() => {
      commit("SEND_NOTIFICATION_SUCCESS", {
        message: "Pomyślnie wysłano wiadomość",
        status: true,
      });
    })
    .catch((err) => {
      console.log(err.response);
      commit("SEND_NOTIFICATION_FAIL", {
        message: "Błąd przy wysyłaniu wiadomości",
        status: false,
      });
    });
};
const sendUsersPushMessage = ({ commit }, data) => {
  axios
    .post(data.url, data.message)
    .then(() => {
      commit("SEND_NOTIFICATION_SUCCESS", {
        message: "Pomyślnie wysłano wiadomość push",
        status: true,
      });
    })
    .catch((err) => {
      commit("SEND_NOTIFICATION_FAIL", {
        message: "Błąd przy wysyłaniu wiadomości",
        status: false,
      });
      console.log(err.response);
    });
};
const sendUsersEmail = ({ commit }, data) => {
  axios
    .post(data.url, data.message)
    .then(() => {
      commit("SEND_NOTIFICATION_SUCCESS", {
        message: "Pomyślnie wysłano email",
        status: true,
      });
    })
    .catch((err) => {
      commit("SEND_NOTIFICATION_FAIL", {
        message: err.response.data.message,
        status: false,
      });
      console.log(err.response);
    });
};
const getUserServices = ({ commit }) => {
  const url = `/api/userService`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_USER_SERVICES", response);
    })
    .catch((err) => {
      commit("SET_USER_SERVICES_ERROR", err);
      console.log(err.response);
    });
};
const suggestUserService = ({ commit }, data) => {
  const url = `/api/admin/suggest-user-service?user_id=${data.userId}&user_service_id=${data.serviceId}`;
  axios
    .post(url)
    .then(() => {
      commit("SEND_NOTIFICATION_SUCCESS", {
        message: "Pomyślnie wysłani propozycję",
        status: true,
      });
    })
    .catch(() => {
      commit("SEND_NOTIFICATION_FAIL", {
        message: "Nie udało się wysłać propozycji",
        status: false,
      });
    });
};
const getUsersWithUnverifiedPhotos = ({ commit }) => {
  const url = `/api/admin/unverified-users-photos`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_PROFILES_WITH_UNVERIFIED_PHOTOS", response.data);
    })
    .catch((err) => {
      commit("SET_PROFILES_WITH_UNVERIFIED_PHOTOS_ERROR", err.response);
      console.log(err.response);
    });
};
const setUserToNull = ({ commit }) => {
  commit("SET_SELECTED_USER", null);
};
const fetchUserByPhoneOrUserId = ({ commit, dispatch }, data) => {
  const url = `/api/user/findByParam/${data.param}`;
  commit("SET_SELECTED_USER", null);
  commit("SET_SELECTED_USER_ERROR", null);
  axios
    .get(url)
    .then((response) => {
      commit("SET_SELECTED_USER", response.data);
      dispatch("getUserById", {
        userId: response.data.id,
      });
      if (!data.withoutPush) {
        if (
          router.history.current.path !== `/users/id/${response.data.id}` &&
          !data.withoutRedirect
        ) {
          router.push({ path: `/users/id/${response.data.id}` });
        }
      }
    })
    .catch((err) => {
      commit("SET_SELECTED_USER_ERROR", 400);

      console.log(err);
    });
};

const fetchWaitingUsersCounter = ({ commit }) => {
  const url = `/api/profile/needVerification`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_WAITING_USERS_COUNTER", response.data.total_value);
    })
    .catch((err) => console.log(err));
};

const fetchNumberOfUnreadMessagesCounter = ({ commit }) => {
  const url = `/api/chat/unreadChatsNumber`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_NUMBER_OF_UNREAD_MESSAGES", response.data);
    })
    .catch((err) => console.log(err));
};

const setCounterUnreadChats = ({ commit }, number) => {
  //if (router.currentRoute.name !== "messages") {
  commit("SET_NUMBER_OF_UNREAD_MESSAGES", number);
  //}
};

const fetchNumberOfUsersWhoTriedToLogIn = ({ commit }) => {
  const url = `/api/profile/triedToLogInNumber`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_NUMBER_OF_USERS_WHO_TRIED_TO_LOGIN", response.data);
    })
    .catch((err) => console.log(err));
};

const setCounterUserWhoTriedLogin = ({ commit }, counter) => {
  commit("SET_NUMBER_OF_USERS_WHO_TRIED_TO_LOGIN", counter);
};

const setWaitingToAcceptEmployeesCounter = ({ commit }, counter) => {
  commit("SET_WAITING_USERS_COUNTER", counter);
};

const fetchUsersWithTheirCommisions = async ({ commit }, data) => {
  const filter_param = data.search_param
    ? `filter_param=${data.search_param}&`
    : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `page_number=${data.on_page}&` : "";

  const url = `/api/admin/user-commissions?${filter_param}${page_number}${on_page}`;
  const requestId = userCommissionsSeq.next();
  await axios
    .get(url)
    .then((response) => {
      if (!userCommissionsSeq.isLatest(requestId)) return;
      commit("SET_USERS_WITH_COMMISSIONS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchAllAdmins = async ({ commit }) => {
  const url = `/api/admin/all`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_ADMINS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchWaitingUsersWithoutPayment = ({ commit }, data) => {
  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";
  const url = `/api/profile/needVerificationPending?${page_number}${on_page}`;
  axios.get(url).then((res) => {
    commit("SET_WAITING_USERS_WITHOUT_PAYMENT", res.data);
  });
};

const fetchSmsListForUser = ({ commit }, data) => {
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const url = `/api/smsFromAdmin/${data.search_param}?${page_number}${on_page}`;
  const requestId = smsListForUserSeq.next();
  axios.get(url).then((res) => {
    if (!smsListForUserSeq.isLatest(requestId)) return;
    commit("SET_SMS_LIST", res.data);
  });
};

const fetchSmsListForAllUser = async ({ commit }, data) => {
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const filter_param = data.search_param
    ? `filter_param=${data.search_param}&`
    : "";
  const url = `/api/smsFromAdmin?${page_number}${on_page}${filter_param}`;
  const requestId = smsListForAllUsersSeq.next();
  await axios.get(url).then((res) => {
    if (!smsListForAllUsersSeq.isLatest(requestId)) return;
    commit("SET_SMS_LIST", res.data);
  });
};

const setNullToSmsList = ({ commit }) => {
  commit("SET_SMS_LIST", []);
};

const fetchUsersInSpecifiedArea = async ({ commit }, data) => {
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const url = `/api/user/usersWithServiceInArea?${page_number}${on_page}`;
  const service_id = data.serviceCategoryId ? data.serviceCategoryId : "";
  const sub_category_id = data.subCategoryId ? data.subCategoryId : "";
  const service_option_id = data.serviceId ? data.serviceId : "";
  const user_type = data.userType ? data.userType : "";
  const coordinates = data.coordinates ? data.coordinates : "";
  const radius = data.radius ? data.radius : 30.0;
  // Bez propagacji błędu nieudane wyszukiwanie wyglądało w panelu jak brak reakcji na "Szukaj".
  const response = await axios.post(url, {
    lat: coordinates.lat,
    lng: coordinates.lng,
    service_id: service_id,
    radius: radius,
    order_days: data.order_days,
    sub_category_id,
    service_option_id,
    user_type,
  });
  if (!response) {
    return;
  }
  commit("SET_USERS_IN_SPECIFIED_AREA", response.data);
  return response.data;
};

const fetchUsersInSpecifiedAreaByEmployeeRadius = async ({ commit }, data) => {
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const url = `/api/user/usersWithServiceInAreaByEmployeeRadius?${page_number}${on_page}`;
  const service_id = data.serviceCategoryId ? data.serviceCategoryId : "";
  const coordinates = data.coordinates ? data.coordinates : "";
  const radius = data.radius ? data.radius : 30.0;
  await axios
    .post(url, {
      lat: coordinates.lat,
      lng: coordinates.lng,
      service_id: service_id,
      radius: radius,
      order_days: data.order_days,
    })
    .then((response) => {
      commit("SET_USERS_IN_SPECIFIED_AREA", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getAllCodes = async ({ commit }, filter) => {
  let active = "";
  if (filter === false) {
    active = false;
  }
  if (filter === true) {
    active = true;
  }
  await axios.get(`/api/promotionalCode?active=${active}`).then((response) => {
    commit("SET_PROMOTIONAL_CODES", response.data);
  });
};
const assignCodeToUser = async ({ commit }, obj) => {
  let url = "api/admin/users/" + obj.userId + "/promotionalCodes";

  return await axios
    .post(url, { promotional_code_id: obj.codeId })
    .then((response) => {
      commit("SET_BLANK", "");
      return response;
    })
    .catch((e) => {
      if (e.response.data.error) return e.response.data.error;
    });
};
const removeCodeFromUser = async ({ commit }, obj) => {
  let url =
    "api/admin/users/" + obj.userId + "/promotionalCodes/" + obj.promotionId;
  return await axios
    .delete(url)
    .then((response) => {
      commit("SET_BLANK", "");
      return response;
    })
    .catch((e) => {
      console.log(e);
    });
};

const getAllUserPromotionalCodes = async ({ commit }, userId) => {
  await axios
    .get(`/api/userPromotionalCode?promotional=true&userId=${userId}`)
    .then((response) => {
      commit("SET_USER_PROMOTIONAL_CODES", response.data);
    });
};

const setPromotionalCodesToNull = async ({ commit }) => {
  commit("SET_USER_PROMOTIONAL_CODES", null);
};

const downloadUsersXls = async ({ commit }, data) => {
  let filter = "";
  const employee_status = data.filter || filter;
  const param = data.searchParam || "";
  const shorter_export =
    data.shorterExport !== null ? data.shorterExport : false;
  let params = {
    shorter_export,
    param,
  };
  if (data.filter === "WAITING_WITHOUT_PAYMENT") {
    params.need_verification_and_without_payment = true;
  } else if (data.filter === "WAITING_WITH_STARTED_PAYMENT") {
    params.need_verification_and_without_payment = false;
  } else {
    params.employee_status = employee_status;
  }

  const url = `api/profile/noWaiting/file`;
  axios(url, {
    method: "GET",
    headers: {
      "Content-Disposition": "attachment; filename=user profiles.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
    params,
  })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "users.xls");
      document.body.appendChild(fileLink);
      fileLink.click();
      commit("SET_DOWNLOAD_MESSAGE", "OK");
    })
    .catch((err) => console.log(err));
};

const fetchUserGroupsCounter = async ({ commit }) => {
  await axios.get(`/api/admin/users/counter`).then((response) => {
    commit("SET_USER_GROUPS_COUNTER", response.data);
  });
};

const fetchNumberOfSentSmsesInCurrentMonth = async ({ commit }) => {
  await axios.get(`/api/admin/tmobile-smses-counter`).then((response) => {
    commit("SET_SENT_SMSES_IN_CURRENT_MONTH", response.data);
  });
};

const fetchPartners = async ({ commit }) => {
  await axios
    .get(`/api/seniorappPartners/amountOfAccepted`)
    .then((response) => {
      commit("SET_PARTNERS", response.data);
    });
};

const downloadProfilesToFileByPhoneNumbers = async ({ commit }, data) => {
  const url = `api/user/usersWithServiceInArea/file`;
  const service_id = data.serviceCategoryId ? data.serviceCategoryId : "";
  const sub_category_id = data.subCategoryId ? data.subCategoryId : "";
  const service_option_id = data.serviceId ? data.serviceId : "";
  const user_type = data.userType ? data.userType : "";
  const coordinates = data.coordinates ? data.coordinates : "";
  const radius = data.radius ? data.radius : 30.0;

  const response = await axios(url, {
    method: "POST",
    headers: {
      "Content-Disposition": "attachment; filename=user profiles.xls",
    },
    responseType: "blob",
    data: {
      lat: coordinates.lat,
      lng: coordinates.lng,
      service_id: service_id,
      radius: radius,
      sub_category_id,
      service_option_id,
      user_type,
    },
  });

  const fileURL = window.URL.createObjectURL(new Blob([response.data]));
  const fileLink = document.createElement("a");

  fileLink.href = fileURL;
  fileLink.setAttribute("download", "users.xls");
  document.body.appendChild(fileLink);
  fileLink.click();
  commit("SET_DOWNLOAD_MESSAGE", "OK");
};

const getPhoneNumbersUsersInSpecifiedArea = async ({ commit }, data) => {
  const url = `api/user/usersWithServiceInArea/phones`;
  const service_id = data.serviceCategoryId ? data.serviceCategoryId : "";
  const sub_category_id = data.subCategoryId ? data.subCategoryId : "";
  const service_option_id = data.serviceId ? data.serviceId : "";
  const user_type = data.userType ? data.userType : "";
  const coordinates = data.coordinates ? data.coordinates : "";
  const radius = data.radius ? data.radius : 30.0;

  const response = await axios(url, {
    method: "POST",
    data: {
      lat: coordinates.lat,
      lng: coordinates.lng,
      service_id: service_id,
      radius: radius,
      sub_category_id,
      service_option_id,
      user_type,
    },
  });
  commit("SET_PHONES_NUMBERS_TO_GROUP_MESSAGE", response.data);
  window.localStorage.setItem(
    "phoneNumbersToGroupMessage",
    JSON.stringify(response.data)
  );
};

export default {
  downloadUsersXls,
  getAllProfiles,
  getProfileWithWatingStatus,
  getUserByPhone,
  changeEmployeeStatus,
  getUserById,
  getDeletedUsers,
  deleteUser,
  getProfilesWithoutPagination,
  sendUsersMessage,
  sendUsersPushMessage,
  sendUsersEmail,
  getUserServices,
  suggestUserService,
  getUsersWithUnverifiedPhotos,
  fetchUserByPhoneOrUserId,
  fetchWaitingUsersCounter,
  fetchNumberOfUnreadMessagesCounter,
  setUserToNull,
  sendMessageToUsers,
  fetchUsersWithTheirCommisions,
  fetchAllAdmins,
  fetchWaitingUsersWithoutPayment,
  fetchSmsListForUser,
  fetchSmsListForAllUser,
  setNullToSmsList,
  fetchUsersInSpecifiedArea,
  getAllCodes,
  getAllUserPromotionalCodes,
  setPromotionalCodesToNull,
  getAllProfilesWhoTriedToLogIn,
  fetchNumberOfUsersWhoTriedToLogIn,
  fetchUserGroupsCounter,
  fetchUsersInSpecifiedAreaByEmployeeRadius,
  downloadProfilesToFileByPhoneNumbers,
  getPhoneNumbersUsersInSpecifiedArea,
  setCounterUserWhoTriedLogin,
  setWaitingToAcceptEmployeesCounter,
  setCounterUnreadChats,
  fetchPartners,
  fetchNumberOfSentSmsesInCurrentMonth,
  assignCodeToUser,
  removeCodeFromUser,
  getUserByIdFromMainApp,
};
